var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center flex flex-center"},[_c('div',[_c('div',{staticStyle:{"font-size":"30vh"}},[_vm._v(" 404 ")]),_c('div',{staticStyle:{"opacity":".4"}},[_vm._v(" Oops. No hay nada aquí... ")])])])
}]

export { render, staticRenderFns }